import axios from "../../axios/index.js"


export default {
  GetMyArticles(code) {

    return axios.get("fournisseurs/analytcs/" + code, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },

  getAllDemandeCompteforAdmin() {
    return axios.get("fournisseurs/demandecreation", { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  saveDemandeCompteFournisseur(data) {
    if (data.delaisPaiment != null)
      data.delaisPaiment = data.delaisPaiment.label
    let fromData = new FormData();


    if (data.file1 != null) {
      fromData.append('filename1', data.file1.filename)
      fromData.append('fileURL1', data.file1.fileURL1);
    }
    if (data.file2 != null) {
      fromData.append('filename2', data.file2.filename)
      fromData.append('fileURL2', data.file2.fileURL2);
    }
    if (data.file3 != null) {
      fromData.append('filename3', data.file3.filename)
      fromData.append('fileURL3', data.file3.fileURL3);
    }

    fromData.append('matriculeFisc', data.matriculeFisc);
    fromData.append('delaisPaiment', data.delaisPaiment);
    fromData.append('raisonSociale', data.raisonSociale);
    fromData.append('codePostale', data.codePostale);
    fromData.append('ville', data.ville.designation);
    fromData.append('gouvernorat', data.gouvernorat.designation);
    fromData.append('adresse', data.adresse);
    fromData.append('codeFournisseur', data.codeFournisseur);


    if (data.modePaiCheque)
      fromData.append('modePaiement', 'cheque');
    else if (data.modePaitriate)
      fromData.append('modePaiement', 'traite');
    else if (data.modePaiAutre != null)
      fromData.append('modePaiement', data.modePaiAutre);


    fromData.append('typeAchat', data.typeAchat);
    fromData.append('delaisPaiement', data.delaisPaiement);

    fromData.append('web', data.web);
    fromData.append('fax', data.fax);
    fromData.append('telephoneFixe', data.telephoneFixe);
    fromData.append('telephoneMobile', data.telephoneMobile);
    fromData.append('email', data.email);

    return axios.post("fournisseurs/demandecreation", fromData)
  },
  getFilesById(idfile) {
    return axios.get("files/download/" + idfile, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })

  },
  gteFilesByContexteAndCreePar(con, creePar) {
    return axios.get("files?contexte=" + con + "&creepar=" + creePar, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  }
}
